import angular from 'angular';
import uiRouter from 'angular-ui-router';
import addInputComponent from './addInput.component';

let addInputModule = angular.module('addInput', [
  uiRouter
])

.component('addInput', addInputComponent)

.name;

export default addInputModule;
